import React from 'react';
import { FallbackComponent } from '../../components/fallbackComponent/FallbackComponent';
import { ServerStatusCode } from '../../constants';
import { FallbackWrapper } from '../../utils/errorPage.styles';

interface Props {
  showFullPage?: boolean;
}

export const NoConnection = ({ showFullPage = false }: Props): JSX.Element => {
  return showFullPage ? (
    <FallbackWrapper>
      <FallbackComponent
        fullPage
        showBrandLogo
        statusCode={ServerStatusCode.SERVICE_UNAVAILABLE}
      />
    </FallbackWrapper>
  ) : (
    <FallbackComponent statusCode={ServerStatusCode.SERVICE_UNAVAILABLE} />
  );
};
